import React from 'react';
export function HeroSection() {
  return <section className="mb-12" data-id="element-335">
      <div className="mb-6" data-id="element-336">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-4" data-id="element-337">
          Executive Assistant Mastery Course
        </h1>
        <p className="text-2xl md:text-3xl font-semibold text-blue-600 mb-6" data-id="element-338">
          Be the EA trusted by Leading CEOs
        </p>
      </div>

      <div className="rounded-2xl overflow-hidden mb-6 shadow-xl" data-id="element-339">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/h3hyRfvSTPWr9FUqGeFrPH/Gemini_Generated_Image_ti5bjfti5bjfti5b.png" alt="Executive Assistant Mastery Course" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-340" />
      </div>

      <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-lg" data-id="element-341">
        <p className="text-sm text-blue-900" data-id="element-342">
          <span className="font-bold text-lg" data-id="element-343">Next Cohort Starting Soon</span>
          <br data-id="element-344" />
          <span className="text-base" data-id="element-345">
            Secure your spot before all seats are filled. Limited to 20
            participants per cohort.
          </span>
        </p>
      </div>
    </section>;
}